
import React from 'react';
import { MetricFormatter, getTimingColor } from './MetricFormatter';

interface ResourcesTabProps {
  metrics: any;
}

const ResourcesTab: React.FC<ResourcesTabProps> = ({ metrics }) => {
  return (
    <div className="mt-1">
      <div className="max-h-40 overflow-auto">
        {metrics.resourceTimings && metrics.resourceTimings.length > 0 ? (
          metrics.resourceTimings.map((resource: any, index: number) => (
            <div key={index} className="mb-1 border-b border-gray-100 dark:border-gray-700 pb-1">
              <div className="flex justify-between">
                <span className="truncate max-w-[180px]" title={resource.name}>
                  {resource.name.split('/').pop()?.split('?')[0] || resource.name}
                </span>
                <span className={getTimingColor(resource.duration)}>
                  <MetricFormatter value={resource.duration} type="time" />
                </span>
              </div>
              <div className="text-[10px] text-gray-500">
                {resource.initiatorType} • 
                {resource.transferSize 
                  ? ` ${resource.transferSize ? <MetricFormatter value={resource.transferSize} type="size" /> : ' Size unknown'}` 
                  : ' Size unknown'}
              </div>
            </div>
          ))
        ) : (
          <div className="text-gray-500">No slow resources detected.</div>
        )}
      </div>
    </div>
  );
};

export default ResourcesTab;
